import { request } from "@/api";
import type {
  OrderItem,
  OrderParams,
  FetchOrdersParams,
  OrderSummary,
} from "@/shared/types";
import { OrderStatus } from "@/shared/enums";

export const fetchOrders = async (params: FetchOrdersParams) => {
  return await request<OrderItem[]>("/orders", {
    params,
  });
};

export const fetchOrderById = async (orderId: string, signal: AbortSignal) => {
  return await request<OrderItem>(`/orders/${orderId}`, { signal });
};

export const fetchOrderCreate = async (body: OrderParams) => {
  return await request<{ createdOrderId: number }>("/orders", {
    method: "POST",
    body,
  });
};

export const fetchChangeOrderStatus = async (
  orderId: string | number,
  status: OrderStatus,
  tfaCode?: string
) => {
  const body: Record<string, string> = { status };
  if (status === OrderStatus.Complete && tfaCode) {
    body.tfaCode = tfaCode;
  }
  return await request(`/orders/${orderId}`, {
    method: "POST",
    body,
  });
};

export const fetchOrdersSummary = async () => {
  return await request<OrderSummary>("/orders/summary");
};

interface OrderPreview {
  platformFeePer: number;
  fee: number;
  amountCrypto: number;
  amountFiat: number;
  currencyOut: string;
  currencyIn: string;
  exchangeRate: number;
  exchangeRateUnit: number;
}

export const fetchOrderPreview = async (
  offerId: number,
  currency: "crypto" | "fiat",
  amount: number,
  signal?: AbortSignal
) => {
  return await request<OrderPreview>(`/orders/preview`, {
    params: {
      offerId,
      currency,
      amount,
    },
    signal,
  });
};
